import React, { useContext } from "react";
import { ScenarioFirstPage, AddScenario, DeviceDetails } from "./";
import { ScenarioSection } from "../../context/ScenarioContext";
import { useTranslation } from "react-i18next";
const Scenario = () => {
  const { scenarioPage } = useContext(ScenarioSection);
  const { t } = useTranslation();
  return (
    <>
      <div className="d-flex align-items-center weatherStatus mb-4">
        <i className="circleTop icon-plug text-center"></i>
        <div className="text-center mr-4">
          <p className="m-2"> {t("سناریوها")}</p>
        </div>
      </div>
      <div style={{ minHeight: "72vh" }} className="px-3">
        {scenarioPage.firstPage && <ScenarioFirstPage />}
        {scenarioPage.addPage && <AddScenario />}
        {scenarioPage.deviceDetails && <DeviceDetails />}
      </div>
    </>
  );
};

export { Scenario };
